// icons/car.svg
export const CarIconV2 = (props) => (
  <svg
    className={props.className}
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.57123 4.03597L3.08468 11.3402V23.9267H0.6875V10.9434L3.31435 3.22699L3.3208 3.20979C3.94939 1.53356 5.47067 0.354492 7.15988 0.354492H18.8261C20.594 0.354492 22.2054 1.4639 22.6891 3.27566L25.4583 10.9317V23.9267H23.0612V11.3519L20.395 3.98074L20.3801 3.92134C20.2033 3.21412 19.5945 2.75167 18.8261 2.75167H7.15988C6.61496 2.75167 5.90406 3.16581 5.57123 4.03597Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.88611 17.9338H24.2598V20.331H1.88611V17.9338Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.88611 8.34521H24.2598V10.7424H1.88611V8.34521Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.88611 13.1394H7.47952V15.5366H1.88611V13.1394Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6664 13.1394H24.2598V15.5366H18.6664V13.1394Z"
      fill="#34363E"
    />
  </svg>
);
